import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="清文華泉"
        brandName="清文華泉"
        englishName="CINVA"
        tagline="以清晰、易懂的內容，讓知識走進日常"
      />
      <Footer />
    </>
  );
}

